import { CurrentOnboarding } from '../../generated/auth/models/Sasfin/Wealth/Online/BL/Models/Onboarding/current-onboarding';

export interface IOnboardingInfoState {
  list: CurrentOnboarding[];
  isLoading: boolean;
  selected?: CurrentOnboarding;
  currentOnboardingId?: number;
}

export const initialUIState: IOnboardingInfoState = {
  list: [],
  isLoading: false,
  // selected: null,
};
